import Vue from 'vue'
import Vuex, {mapGetters} from 'vuex'
import axios from 'axios'

import auth from './modules/auth'
import user from './modules/user'
import popup from './modules/popup'
import loading from './modules/loading'
import languages from './modules/languages'
import page from './modules/page'
import translations from './modules/translations'
import interfaceAdmin from './modules/interface/interfaceAdmin'
import interfaceGroup from './modules/interface/interfaceGroup'
import employee from './modules/employee/employee'
import employeeGroup from './modules/employee/employeeGroup'
import employeeDoc from './modules/employee/employeeDoc'
import employeeRoles from './modules/employee/employeeRoles'
import employeeWorkDay from './modules/employee/employeeWorkDay'
import employeeSalaryPeriod from './modules/employee/salary/employeeSalaryPeriod'
import employeeSalaryManual from "@/store/modules/employee/salary/employeeSalaryManual"
import employeeSalaryReport from "@/store/modules/employee/salary/employeeSalaryReport"
import employeeSalaryInfo from "@/store/modules/employee/salary/employeeSalaryInfo";

import commonUser from './modules/commonUser'
import commonRole from './modules/commonRole'
import commonVatCode from './modules/commonVatCode'
import commonPaymentTerms from './modules/commonPaymentTerms'
import commonContent from './modules/commonContent'
import workType from './modules/work/workType'
import workExtraType from './modules/work/workExtraType'
import workRegion from './modules/work/workRegion'
import workTypeCategory from './modules/work/workTypeCategory'
import workProjectType from './modules/work/workProjectType'
import workBusinessSegment from './modules/work/workBusinessSegment'
import workClient from './modules/work/client/workClient'
import workClientAddress from './modules/work/client/workClientAddress'
import workClientContact from './modules/work/client/workClientContact'
import workClientPerson from './modules/work/client/workClientPerson'
import workClientOffices from './modules/work/client/workClientOffices'
import workClientProject from './modules/work/client/workClientProject'
import workClientProjectsWorkType from './modules/work/client/projects/workClientProjectsWorkType'
import workClientProjectsWorkTypePeriod from './modules/work/client/projects/workClientProjectsWorkTypePeriod'
import workClientProjectsResponsibleEmployees from './modules/work/client/projects/workClientProjectsResponsibleEmployees'
import workClientProjectsPeriodReport from './modules/work/client/projects/workClientProjectsPeriodReport'
import workClientProjectsPeriodReportUpdate from "./modules/work/client/projects/workClientProjectsPeriodReportUpdate"
import workClientProjectsSubscribers from './modules/work/client/projects/workClientProjectsSubscribers'
import workClientProjectsClientReports from './modules/work/client/projects/client-reports/workClientProjectsClientReports'
import workClientProjectsClientBills from './modules/work/client/projects/client-bills/workClientProjectsClientBills'
import workClientInvoicingCompany from './modules/work/client/workClientInvoicingCompany';

import workDocsProjectSchemes from './modules/work/docs/workDocsProjectSchemes'
import workDocsProjectDocuments from './modules/work/docs/workDocsProjectDocuments'
import workDocsDocumentType from './modules/work/docs/workDocsDocumentType'
import workDocsSchemeClass from './modules/work/docs/workDocsSchemeClass'
import workDocsSchemeType from './modules/work/docs/workDocsSchemeType'
import workDocsWorkArea from './modules/work/docs/workDocsWorkArea'
import offerAgreement from './modules/offerAgreement'
import freeDocumentsGroups from './modules/freeDocuments/freeDocumentsGroups'
import freeDocuments from './modules/freeDocuments/freeDocuments'

import guest_periodReport from './modules/guest/periodReport/guest_periodReport'

import notificationAdminManual from './modules/notification/admin/notificationAdminManual'
import notificationAdminTriggered from './modules/notification/admin/notificationAdminTriggered'
import notificationAdminProject from './modules/notification/admin/notificationAdminProject'
import notificationUser from './modules/notification/user/notificationUser'

import commonConfig from './modules/commonConfig'
import commonWidgets from './modules/commonWidgets'

import firebase from './modules/firebase'

import navigationGuardian from './modules/navigationGuardian'
import chat from './modules/chat'
import record from './modules/record'

import config from '../../client'
Vue.use(Vuex)
const store = new Vuex.Store({
  namespaced: true,
  modules: {
    auth,
    user,
    popup,
    commonUser,
    commonRole,
    commonVatCode,
    commonPaymentTerms,
    commonContent,
    employee,
    employeeRoles,
    employeeDoc,
    employeeGroup,
    employeeWorkDay,
    employeeSalaryPeriod,
    employeeSalaryManual,
    employeeSalaryReport,
    employeeSalaryInfo,
    loading,
    languages,
    page,
    translations,
    interfaceAdmin,
    interfaceGroup,
    workType,
    workExtraType,
    workTypeCategory,
    workProjectType,
    workBusinessSegment,
    workClient,
    workClientAddress,
    workClientContact,
    workClientPerson,
    workClientOffices,
    workClientProject,
    workRegion,
    workDocsProjectSchemes,
    workDocsProjectDocuments,
    workDocsDocumentType,
    workDocsSchemeClass,
    workDocsSchemeType,
    workDocsWorkArea,
    workClientProjectsWorkType,
    workClientProjectsWorkTypePeriod,
    workClientProjectsResponsibleEmployees,
    workClientProjectsPeriodReport,
    workClientProjectsPeriodReportUpdate,
    workClientProjectsSubscribers,
    workClientProjectsClientReports,
    workClientProjectsClientBills,
    workClientInvoicingCompany,
    offerAgreement,
    freeDocumentsGroups,
    freeDocuments,
    commonConfig,
    commonWidgets,
    guest_periodReport,
    notificationAdminManual,
    notificationAdminTriggered,
    notificationAdminProject,
    notificationUser,
    firebase,
    navigationGuardian,
    chat,
    record
  },
  state: {
    configData: config,
    apiDomain: config.api,
    chatApiDomain: config.chat_api,
    apiUrls: {
      work: {
        group: '/api/admin/work/group',
        type: '/api/admin/work/type',
        object: '/api/admin/work/object',
        // object_type: '/api/admin/work/object/type',
        // object_group: '/api/admin/work/object/group',
        grid_one: '/api/admin/work/objects-with-types',
      },
    },
    items: null,
    typeItems: null,
    pageData: null,
    uploadProgress: 0,
    companiesConfig: [],
    loadingAnimation: false,
    loadingAnimationFullPage: false,
    userInterface: null,
    inputRules: {},
    userAgreementNotAccepted: false,
    useProtocol: window.location.protocol,
    pathAfterAuth: null,
    // loggedIn: false,
    pdfLoader: [],
    showPdfLoader: false,
  },
  getters: {
    apiDomain: (state) => state.apiDomain,
    uploadProgress: (state) => state.uploadProgress,
    companiesConfig: (state) => state.companiesConfig,
    loadingAnimation: (state) => state.loadingAnimation,
    loadingAnimationFullPage: (state) => state.loadingAnimationFullPage,
    userInterface: (state) => state.userInterface,
    inputRules: (state) => state.inputRules,
    checkUseProtocol: (state) => (state.useProtocol === 'http:' ? false : true),
    pdfLoader: (state) => state.pdfLoader,
    showPdfLoader: (state) => Object.keys(state.pdfLoader).length > 0,

  },
  mutations: {
    setItems(state, payload) {
      state.items = payload
    },
    setTypeItems(state, payload) {
      state.typeItems = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
    setBreadCrumbs(state, payload) {
      state.breadCrumbs = payload
    },
    setUploadProgress(state, payload) {
      state.uploadProgress = payload
    },
    setCompaniesConfig(state, payload) {
      state.companiesConfig = payload
    },
    setLoadingAnimation(state, payload) {
      state.loadingAnimation = payload
    },
    setUserInterface(state, payload) {
      state.userInterface = payload
    },
    setInputRules(state, payload) {
      state.inputRules = payload
    },
    setLoadingAnimationFullPage(state, payload) {
      state.loadingAnimationFullPage = payload
    },
    setPdfLoader(state, payload) {
      state.pdfLoader = payload
    },
  },
  actions: {
    onLoadingAnimationFullPage({commit}, {value}) {
      commit('setLoadingAnimationFullPage', value)
    },
    onCompaniesConfig: async ({ commit, rootState }) => {
      try {
        const [companies, accountSettings, projectSettings, reportSettings] = await Promise.all([
          axios.get('https://service.proapp.fi/companies.json'),
          axios.get(rootState.apiDomain + '/api/common/config/account_settings'),
          axios.get(rootState.apiDomain + '/api/common/config/project_settings'),
          axios.get(rootState.apiDomain + '/api/common/config/report'),
        ])

        const temp = Object.assign(
          {},
          companies.data[config.name],
          accountSettings.data,
          projectSettings.data,
          reportSettings.data,
        )

        commit('setCompaniesConfig', temp)
      } catch (error) {
        console.error('Failed to load companies config', error)
        throw error
      }
    },
    getItems: async (context, payload) => {
      let apiUrl = payload.apiUrl
      let filter = payload.filter
      await axios.get(context.state.apiDomain + apiUrl + filter).then((response) => {
        context.commit('setItems', response.data.data)
        context.commit('setPageData', response.data)
      })
    },
    getTypeItems: async (context, payload) => {
      let apiUrl = payload.apiUrl
      let filter = payload.filter
      await axios.get(context.state.apiDomain + apiUrl + filter).then((response) => {
        context.commit('setTypeItems', response.data.data)
      })
    },
    uploadFile({ commit, rootState }, { data, use_case, guest }) {
      return new Promise((resolve, reject) => {
        let progress = 0
        let url = rootState.apiDomain + (!guest ? '/api/uploadfile' : '/api/user/uploadfile')
        if (use_case) {
          url = url + '?use_case=' + use_case
        }
        axios({
          url,
          data: data,
          method: 'POST',
          onUploadProgress: (e) => {
            progress = Math.round((e.loaded * 100) / e.total)
            commit('setUploadProgress', progress)
          },
        })
          .then((resp) => {
            return resolve(resp)
          })
          .catch((err) => {
            return reject(err)
          })
      })
    },
    uploadFiles({ commit, rootState }, { data, use_case }) {
      return new Promise((resolve, reject) => {
        const myUploadProgress = (myFileId) => (progress) => {
          let percentage = Math.floor((progress.loaded * 100) / progress.total)
        }

        for (var i = 0; i < files.length; i++) {
          var config = {
            onUploadProgress: myUploadProgress(files[i].id),
          }
          axios(
            {
              url: rootState.apiDomain + '/api/uploadfile' + '?use_case=' + use_case,
              data: data,
              method: 'POST',
            },
            config,
          )
        }
      })
    },
    async getFromLink({ rootState }, link) {
      await axios.get(rootState.apiDomain + link)
    },
    deleteFile({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/destroyfile',
          data: data,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onUserInterface({ rootState }, { language_name, page_url }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/user/interface/page/' + language_name + '/' + page_url,
          data: data,
          method: 'GET',
        })
          .then((resp) => {
            commit('setUserInterface', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onExtendPdfLoader({commit, rootState}, data) {
      let temp = [].concat(rootState.pdfLoader)
      let index = temp.map(i => i.id).indexOf(data.id)
      if (index !== -1) {
        for (let field in data) {
          temp[index][field] = data[field]
        }
      } else {
        temp.push(data)
      }
      commit('setPdfLoader', temp)
    },
    onDeleteItemPdfLoader({commit, rootState}, id) {
      let temp = [].concat(rootState.pdfLoader)
      let index =temp.map(i => i.id).indexOf(id)
      if (index !== -1) {
        temp.splice(id, 1)
        commit('setPdfLoader', temp)
      }
    }
  },
})

export default store
